import React from "react";

export default function LilyContexte() {
	return (
		<>
			{/* <h4 className='title'>Lily Context</h4> */}
			<p className='description'>
				Au tout début du spectacle les comédiens et comédiennes se remémorent
				<span className='oliver'> des souvenirs de leur enfance...</span>
			</p>
			<div className='video_container'>
				<iframe
					width='560'
					height='315'
					src='https://www.youtube.com/embed/Iix6vOZpPW8?si=xKSJDWRcfYMMSKFI'
					title='Capsule Lily'
					frameBorder='0'
					allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
					allowFullScreen></iframe>
			</div>
		</>
	);
}
